<template>
  <div>
    <div v-if="user.available_date" class="row">
      <div class="col-lg-6 px-4">
        <label v-if="user.features[0]" style="margin-top: 0;">I have the following valid</label>
        <ul>
          <li v-for="(feature, index) in user.features" :key="'Feature'+index">{{ feature }}</li>
        </ul>
        <label v-if="user.available_date" style="">Available Start Date</label>
        <p>{{ new Date(user.available_date).toDateString() }}</p>
        <label v-if="user.preferences2[0]" style="">Days I am available</label>
        <ul>
          <li v-for="(preference2, index) in user.preferences2" :key="'Preference2'+index">{{ preference2 }}</li>
        </ul>
      </div>
      <div class="col-lg-6 px-4">
        <label v-if="user.text6" style="margin-top: 0;">How long I can commit</label>
        <p>{{ user.text6 }}</p>
        <label v-if="user.text7" style="">Hours per week I'm looking for</label>
        <p>{{ user.text7 }}</p>
        <label v-if="user.text8" style="">Schedule considerations</label>
        <p>{{ user.text8 }}</p>
        <label v-if="user.text1" style="">My ideal nanny family</label>
        <p>{{ user.text1 }}</p>
        <div v-if="editAccess">
          <label v-if="user.boolean_selector3">I have an active profile on a nanny job site.</label>
          <label v-if="!user.boolean_selector3">I don't have an active profile on a nanny job site.</label>
          <p>{{ user.text9 }}</p>
          <label v-if="user.marketing_source" style="">How did I hear about The Nanny Company</label>
          <p>{{ user.marketing_source }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['user'],
  computed: {
    editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
    viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/DesiredRole.vue